import React from 'react';
import './Contact.css'

const ContactMe = () => (
  <div className='contactcontainer'>
    <h1 className='contact-title'>Contact</h1>
    <h3 className='contact-title'> Get in touch: </h3>
    <a className='contact-text' href="mailto:hyltonakil@gmail.com">hyltonakil@gmail.com </a>
      </div>
      );

export default ContactMe;



// WEBPACK FOOTER //
// ./src/container/Contact/Contact.js